import _ from 'lodash';

import {
  getBottomLine,
  getConsBullets,
  getId,
  getLearnMoreLink,
  getProsBullets,
} from '@nerdwallet/marketplace/selectors/common';
import {
  getAdvisorFeePeriod,
  getAdvisorFee,
} from '@nerdwallet/marketplace/selectors/investing';

/**
 * Get the "Best for" bullets for an Investing entity.
 * @todo - Backport into @nerdwallet/marketplace/investing
 *
 * @param {Object} entity - The Investing marketplace entity.
 * @returns {Array<String>} - The "Best for" bullets.
 */
const getBestForBullets = (entity) => _.get(entity, 'additional_data.best_for');

/**
 * Get the WordPress Review slug for an Investing entity.
 *
 * @param {Object} entity - The Investing marketplace entity.
 * @returns {String} - The WordPress Review slug.
 */
const getWpReviewSlug = (entity) =>
  _.get(entity, 'details.wp_review_slug.value');

// @nerdwallet/react-product-table expects to get data that has been processed by @nerdwallet/react-wp-product-sdk
// for some of the components it provides. So that we can continue to use that code until we're ready to
// migrate fully to the universal product table, we manually provide a few pieces of data at the keys that
// @nerdwallet/react-product-table expects here.
// TODO: remove this once we no longer use @nerdwallet/react-product-table.
export const mapEntity = (entity) => ({
  ...entity,
  bestFor: getBestForBullets(entity),
  bottomLine: getBottomLine(entity),
  cons: getConsBullets(entity),
  feePeriod: getAdvisorFeePeriod(entity),
  managementFee: getAdvisorFee(entity),
  pros: getProsBullets(entity),
  review: getLearnMoreLink(entity),
});

export const formatInvestingProducts = (marketplaceEntities) =>
  _.reduce(
    marketplaceEntities,
    (allProducts, entity) => ({
      ...allProducts,
      // we temporarily store products under both their slug and their id while the fetch accepts both
      // TODO: remove the wp_review_slug index once all investing landing pages use id rather than slug
      [getWpReviewSlug(entity)]: mapEntity(entity),
      [getId(entity)]: mapEntity(entity),
    }),
    {}
  );
